const TextInstruction = ({ text }) => {
    return <div className="text-sm sm:text-base md:text-lg text-center m-3">{text}</div>;
};

export default TextInstruction;
